import { NAMESPACE } from './constants';

export const CLEANUP = `${NAMESPACE}/CLEANUP`;

export const SUBSCRIBE_BUILDS = `${NAMESPACE}/SUBSCRIBE_BUILDS`;
export const UNSUBSCRIBE_BUILDS = `${NAMESPACE}/UNSUBSCRIBE_BUILDS`;
export const SAVE_BUILDS_TIMEOUT = `${NAMESPACE}/SAVE_BUILDS_TIMEOUT`;
